import Axios from "axios";
import {
    SET_PRODUCT_TYPE_LIST,
    UNSET_PRODUCT_TYPE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateProductType, getProductTypeList } from "@/store/api";
// initial state
const state = {
  getProductTypeList: [],
};

const getters = {
  getProductTypeList(state) {
    return state.getProductTypeList;
  },
};

const mutations = {
  [SET_PRODUCT_TYPE_LIST](state, data) {
    state.getProductTypeList = data;
  },
  [UNSET_PRODUCT_TYPE_LIST](state) {
    state.getProductTypeList = [];
  }
};

const actions = {

  saveUpdateProductType({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateProductType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getProductTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getProductTypeList, data)
        .then(function (response) {
          commit('SET_PRODUCT_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_PRODUCT_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  }

};

export default {
  state,
  getters,
  actions,
  mutations,
};
